import axios from 'axios';
import { config } from '../../../../config/envs';
import { generateTraceId } from '../../../helpers';

const BASE_URL = config.app.baseUrl;

export class ClientsAPI {
  static async settleCharge(clientId) {
    const response = await axios.post(
      `${BASE_URL}/clients/settleCharge`,
      { id: clientId },
      { headers: { 'x-trace-id': generateTraceId() } },
    );
    return response;
  }
}
